const checkIfLinkIsCurrent = (
	routePath: string,
	link?: string,
	subLinks: string[] = [],
	options: {strict?: boolean} = {},
): {
	current: boolean
	parent: boolean
} => {
	const {strict = false} = options

	const normalize = (str: string, stripHash = true): string => {
		if (!str) return ""
		let url = decodeURIComponent(str).trim()

		if (stripHash) {
			url = url.replace(/#.*$/, "")
		}

		return url !== "/" ? url.replace(/\/+$/, "") : "/"
	}

	const cleanedRoute = normalize(routePath)
	const cleanedLink = link ? normalize(link) : ""

	const current =
		typeof link !== "undefined" &&
		(strict
			? cleanedRoute === cleanedLink
			: cleanedRoute === cleanedLink ||
			  cleanedRoute.startsWith(`${cleanedLink}/`))

	const parent = subLinks.some((sub) => {
		const cleanedSub = normalize(sub)
		return (
			cleanedRoute === cleanedSub ||
			cleanedRoute.startsWith(`${cleanedSub}/`)
		)
	})

	return {
		current,
		parent,
	}
}

export default checkIfLinkIsCurrent
